import { PROFILE_PLACEMENT_MODES } from '../profileContract/profilePlacementMetadata';

export const CAREGIVER_PROFILE_ADD_EXTRACTION_VERSION = 'caregiver_profile_add_v1';

export const isCaregiverAuthoredProfileFact = (fact = {}) => {
  const sourceRefs = Array.isArray(fact?.sourceRefs) ? fact.sourceRefs : [];
  const hasDirectProfileTextSource = sourceRefs.length > 0
    && sourceRefs.every((sourceRef) => sourceRef?.sourceType === 'care_knowledge');

  return Boolean(String(fact?.id || '').trim())
    && fact?.profilePlacementMode === PROFILE_PLACEMENT_MODES.EXPLICIT_CAREGIVER
    && Boolean(String(fact?.profileChapterId || '').trim())
    && fact?.capturedBy?.authorship === 'caregiver'
    && fact?.extractionVersion === CAREGIVER_PROFILE_ADD_EXTRACTION_VERSION
    && hasDirectProfileTextSource;
};
